(() => {
  const form = document.querySelector('#mc-cart-form');
  if (!form) return;
  let submitting = false;
  form.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-delta]');
    if (!button || submitting) return;
    const input = document.querySelector('#mc-quantity-' + button.dataset.line);
    input.value = Math.max(0, Number(input.value) + Number(button.dataset.quantityDelta));
    submitting = true;
    form.requestSubmit(document.querySelector('#mc-update-cart'));
  });
  form.addEventListener('submit', () => {
    for (const input of form.querySelectorAll('[name="updates[]"]')) {
      if (!Number.isInteger(Number(input.value)) || Number(input.value) < 0) {
        input.value = Math.max(0, Math.floor(Number(input.value) || 0));
      }
    }
  });
})();
